import { Company } from '@/types/company'
import { includesIgnoringCase } from '@/utils'

export const filterCompanies = (companies: Company[] = [], search: string) =>
  companies
    .filter(
      (company) =>
        includesIgnoringCase(search, company.name) ||
        company.locations.find((location) =>
          includesIgnoringCase(search, location.name),
        ),
    )
    .map((company) => {
      const filteredCompany = company.locations.filter((location) =>
        includesIgnoringCase(search, location.name),
      )
      const isPerfectMatch = search.toLowerCase() === company.name.toLowerCase()
      return {
        ...company,
        locations: isPerfectMatch ? company.locations : filteredCompany,
      }
    })
